import React, {
  FC,
  useEffect,
} from 'react';
import { useLocation } from 'react-router-dom';
import { ENV } from '@/infrastructure/env-config';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { useReportPage } from '@/infrastructure/reporter/datong/report';
import { Header } from '@/presentation/pages/main/header';
import style from './index.module.scss';

const RightlyHomepage: FC = () => {
  useReportPage(PAGE_ID.compliance.homepage);
  const { pathname } = useLocation();
  const embed = pathname.startsWith('/compliance');

  useEffect(() => {
    if (embed) {
      localStorage.setItem('compliance-new', 'true');
    }
  }, [embed]);

  return <div className={style.homepage}>
    {!embed ? <Header /> : null}
    <iframe className={style.iframe} src={`https://${ENV.isProd ? '' : 'test.'}rightly.tds.qq.com?insideBugly=${embed ? 'contentpage' : 'homepage'}`} />
  </div>;
};

export default RightlyHomepage;
